export default __webpack_public_path__ + "static/media/45.a6b1d356.jpeg";